<template>
    <VContent>
        <VContainer fill-height>
            <VLayout
                    align-content-center
                    mx-auto
                    wrap
            >
                <VFlex xs12 sm8 offset-sm2 md5 offset-md4 >
                    <BaseCard>
                        <VCardTitle class="title font-weight-light">
                            <v-avatar tile size="40" class="mr-2">
                                <img :src="require('@/assets/mstile-150x150.png')" />
                            </v-avatar>
                           Sign Up <span v-if="entercode" class="pl-2"> with Confirmation Code</span>
                        </VCardTitle>
                        <VCardText
                                pa-0
                                grid-list-xl
                        >
                            <VLayout>
                                <VFlex xs12 class="info--text font-weight-light subtitle-1 pb-4">
                                    {{errormessage}}
                                </VFlex>
                            </VLayout>
                            <VLayout>
                                <VFlex xs12>
                                    <VForm
                                            ref="form"
                                            v-model="form"
                                            class="mb-5"
                                            lazy-validation
                                    >
                                        <VContainer pa-0>
                                            <VLayout wrap>
                                                <VFlex xs12>
                                                    <!--<VTextField-->
                                                        <!--v-model="email"-->
                                                        <!--:rules="[rules.required('Enter your email address')]"-->
                                                        <!--label="Email"-->
                                                        <!--name="email"-->
                                                        <!--email-->
                                                        <!--outlined-->
                                                    <!--/>-->
                                                </VFlex>
                                                <VFlex xs12>
                                                    <UserName />
                                                </VFlex>
                                                <VFlex xs12>
                                                    <VTextField
                                                        v-model="password"
                                                        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                                        :rules="[$store.state.rules.required]"
                                                        :type="show ? 'text' : 'password'"
                                                        hint="Must contain at least one number, one capital and one lowercase letter"
                                                        label="Password"
                                                        persistant-hint
                                                        outlined
                                                        @click:append="show = !show"
                                                    />
                                                </VFlex>
                                                <VFlex xs12>
                                                    <VTextField
                                                            v-if="entercode"
                                                            v-model="code"
                                                            :rules="[$store.state.rules.required]"
                                                            hint="Enter the code sent via SMS"
                                                            label="Code"
                                                            persistant-hint
                                                            outlined
                                                    />
                                                </VFlex>
                                                <VFlex xs12 class="mt-2">
                                                    <BaseBtn
                                                            v-if="!entercode"
                                                            :disabled="!form"
                                                            :loading="isLoading"
                                                            prominent
                                                            block large
                                                            @click="submitToApi"
                                                    >
                                                        <!--@click="submit"-->
                                                        Sign Up
                                                    </BaseBtn>
                                                    <BaseBtn
                                                            v-else
                                                            :disabled="!form"
                                                            :loading="isLoading"
                                                            prominent
                                                            block large
                                                            @click="confirm">
                                                        Confirm
                                                    </BaseBtn>
                                                </VFlex>
                                            </VLayout>
                                        </VContainer>
                                    </VForm>
                                </VFlex>
                            </VLayout>

                            <VLayout wrap>
                                <VFlex xs12 v-if="!entercode">
                                    <p class="text-center pa-2" >
                                        By signing up, you agree to our Terms , Data Policy and Cookies Policy .
                                    </p>
                                </VFlex>
                                <VFlex xs12>
                                    <p class="text-center my-2 pa-4" >
                                        Have an account?
                                        <BaseBtn text  to="/auth/signin">
                                            Sign In
                                        </BaseBtn>
                                        <BaseBtn v-if="!entercode" text @click="entercode = !entercode" >
                                            Have Code?
                                        </BaseBtn>
                                        <BaseBtn v-else text @click="entercode = !entercode" >
                                            No Code ?
                                        </BaseBtn>
                                    </p>
                                </VFlex>
                            </VLayout>
                        </VCardText>
                        <VCardActions>
                            <BaseBtn text  to="/" >
                                Home
                            </BaseBtn>
                        </VCardActions>
                    </BaseCard>
                </VFlex>
            </VLayout>
        </VContainer>
    </VContent>
</template>

<script>
  // Utilities
  import {
    mapActions,
    mapMutations
  } from 'vuex'
  import UserName from "./UserName";

  export default {
    components: {UserName},
    data () {
      const data = {
        isLoading: false,
        form: false,
        form2:false,
        firstName: undefined,
        lastName: undefined,
        username: undefined,
        // password: undefined,
        confirmpassword: undefined,
        code: undefined,
        rules: {
          required: msg => v => !!v || msg,
          confirm: v => v ? v === this.password : 'Passwords do not match'
        },
        show: false,
        showConfirm: false,
        entercode:false,
        errormessage:undefined,
        rfghr:undefined
      }
      return data
    },
    computed:{
      password: {
        get () {
          return this.$store.state.password
        },
        set (val) {
          this.$store.commit('setPassword',val)
          window.localStorage.setItem('qhnt',val)
        }
      }
    },
    mounted () {
        if(this.$route.query.redirect==='usernotfoundexception'){
          this.errormessage = 'User not found. Click to register'
        }
        if(this.$route.query.havecode && this.$route.query.havecode==='true'){
          this.entercode = true
        }
    },
    methods: {
      ...mapActions('cognito',['registerUser','confirmUser']),
      ...mapActions(['openPost']),
      ...mapMutations(['setSnackbar']),
      async submitToApi(){
        this.isLoading = true
        let res = await this.openPost({body: {
             app: this.$store.state.app,
             identitypool: this.$store.state.idpool,
             clientid: this.$store.state.client,
             password:this.password.trim(),
             username:this.$store.state.username.trim()
           },
           path:'api/auth/generalusersignup'
        })
        console.log(res)
        this.isLoading = false
        if(res.error){
          switch(res.error.code){
            case 'LimitExceededException':
              this.errormessage = 'An account already exists.'
              this.$router.push('/')
              break;
            case 'UsernameExistsException':
              this.errormessage = 'An account already exists.'
              break;
            case 'UsernameNotConfirmed':
              this.errormessage = res.message
              break;
            case 'PasswordChangeRequired':
              this.$router.push('/auth/forgotpassword?force=true')
              break;
            default:
              break;
          }
          return;
        }
        if(res.CodeDeliveryDetails.DeliveryMedium==='SMS'){
             this.entercode = true
             this.$store.commit('setSnackbar',{
                type: 'success',
                msg: res.message,
                timeout:6000
             })
           } else if (res.CodeDeliveryDetails.DeliveryMedium==='EMAIL') {
              this.$router.push('/auth/confirm')
           }
      },
      confirm () {
        let em = this
        this.isLoading = true
        let uname = this.$store.state.username.trim()
        if(!uname.includes('@')) uname = '+1'+uname
        console.log(uname)
        this.confirmUser({
          username: uname,
          code: this.code.trim()
        }).then(() => {
          em.confirmed=true
          this.setSnackbar({
            type: 'success',
            msg: 'Account confirmed'
          })
          setTimeout(function(){
            em.$router.push('/auth/signin')
          },2000)

        }).catch(err => {
          console.log(err)
              this.setSnackbar({
                type: 'error',
                msg: err.message,
                timeout: 10000
              })
            })
            .finally(() => (this.isLoading = false))
      },
      submit () {
        if (!this.$refs.form.validate()) return
        this.isLoading = true
        window.localStorage.setItem('username', this.username.trim())
        this.registerUser({
          username: this.username.toLowerCase().trim(), // this.username.trim(),
          password: this.password.trim(),
          attributes: {
            name: `first last`,
            email: this.username.toLowerCase().trim()
          }
        }).then((d) => {
          this.setSnackbar({
            type: 'success',
            msg: 'Account created. Check your email for verification'
          })
          this.$router.push('/auth/confirm')
        }).catch(err => {
          this.setSnackbar({
            type: 'error',
            msg: err.message,
            timeout: 10000
          })
        }).finally(() => (this.isLoading = false))

      },
    }
  }
</script>
